import React, { useEffect, useRef, useState } from "react";
import { Dialog, DialogContent, DialogTitle, FormControl, IconButton, MenuItem, Select } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { Description, PropertyObj } from "../../Models/PropertyObj";
import { useTranslation } from "react-i18next";


const UpdateTemplate: React.FunctionComponent<{ template: any, onUpdateTemplate: any }> = (props) => {

    const [open, setOpen] = useState(false);
    const [template, setTemplate] = useState<Description>(props.template);
    const { t } = useTranslation();


    const handleChangeCheck = (event: any) => {
        const { name, checked } = event.target;
        setTemplate((prevOptions: any) => ({
            ...prevOptions,
            [name]: checked,
        }));
    }

    const handleChangeDescTitle = (event: any) => {
        const { name, value } = event.target;
        setTemplate((prevOptions: any) => ({
            ...prevOptions,
            [name]: value,
        }));
    }

    const UpdateTemplateHandler = () => {
        setOpen(false)
        props.onUpdateTemplate(template, props.template._id)
    }

    return (
        <>
            <button type="button" className="btn p-0  hide-arrow" onClick={() => setOpen(true)} >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_1117_1916)">
                        <path d="M4.66699 4.6665H4.00033C3.6467 4.6665 3.30756 4.80698 3.05752 5.05703C2.80747 5.30708 2.66699 5.64622 2.66699 5.99984V11.9998C2.66699 12.3535 2.80747 12.6926 3.05752 12.9426C3.30756 13.1927 3.6467 13.3332 4.00033 13.3332H10.0003C10.3539 13.3332 10.6931 13.1927 10.9431 12.9426C11.1932 12.6926 11.3337 12.3535 11.3337 11.9998V11.3332" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M13.5905 4.39007C13.8531 4.12751 14.0006 3.77139 14.0006 3.40007C14.0006 3.02875 13.8531 2.67264 13.5905 2.41007C13.3279 2.14751 12.9718 2 12.6005 2C12.2292 2 11.8731 2.14751 11.6105 2.41007L6.00049 8.00007V10.0001H8.00049L13.5905 4.39007Z" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M10.667 3.3335L12.667 5.3335" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_1117_1916">
                            <rect width="16" height="16" fill="white" transform="translate(0.000488281)" />
                        </clipPath>
                    </defs>
                </svg>
            </button>

            <Dialog
                fullWidth
                maxWidth="md"
                open={open}
                onClose={() => setOpen(false)}
                aria-describedby="alert-dialog-slide-description">
                <DialogTitle id="customized-dialog-title">
                    <div className="title-24 title-20-mb">
                        {t("aiDescTitle.updateTemplate")}
                    </div>
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={() => setOpen(false)}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent>
                    <div className="padd-0-20 padd-10-mb">
                        <div className="row card-form mb-4">

                            <div className="col-md-4 mb-3">
                                <label className="form-label-1 mb-2" htmlFor="selectTypeOpt">{t("descriptionDetails.length")}</label>
                                <FormControl fullWidth>
                                    <Select
                                        className="input-property"
                                        displayEmpty
                                        inputProps={{ 'aria-label': 'Select' }}
                                        value={template.length || ''}
                                        name="length"
                                        onChange={handleChangeDescTitle}
                                    >
                                        <MenuItem value="" disabled>
                                            {t("propertiesPage.select")}
                                        </MenuItem>
                                        <MenuItem value={"Short and Concise"}>{t("descriptionDetails.shortAndConcise")}</MenuItem>
                                        <MenuItem value={"Medium length"}>{t("descriptionDetails.mediumLength")}</MenuItem>
                                        <MenuItem value={"Detailed and Elaborate"}>{t("descriptionDetails.detailedAndElaborate")}</MenuItem>
                                    </Select>
                                </FormControl>
                            </div>
                            <div className="col-md-4 mb-3">
                                <label className="form-label-1 mb-2" htmlFor="selectTypeOpt">{t("descriptionDetails.tone")}</label>
                                <FormControl fullWidth>
                                    <Select
                                        className="input-property"
                                        displayEmpty
                                        inputProps={{ 'aria-label': 'Select' }}
                                        value={template.tone || ''}
                                        name="tone"
                                        onChange={handleChangeDescTitle}>
                                       <MenuItem value="" disabled> {t("propertiesPage.select")} </MenuItem>
                                                              <MenuItem value={"Formal and Professional"}>{t("descriptionDetails.formalAndProfessional")}</MenuItem>
                                                              <MenuItem value={"Friendly and Welcoming"}>{t("descriptionDetails.friendlyAndWelcoming")}</MenuItem>
                                                              <MenuItem value={"Luxurious and Indulgent"}>{t("descriptionDetails.luxuriousAndIndulgent")}</MenuItem>
                                                              <MenuItem value={"Cozy and Inviting"}>{t("descriptionDetails.cozyAndInviting")}</MenuItem>
                                                              <MenuItem value={"Informative and Descriptive"}>{t("descriptionDetails.informativeAndDescriptive")}</MenuItem>
                                                           </Select>
                                </FormControl>
                            </div>
                            <div className="col-md-4 mb-3">
                                <label className="form-label-1 mb-2" htmlFor="selectTypeOpt">{t("descriptionDetails.style")}</label>
                                <FormControl fullWidth>
                                    <Select
                                        className="input-property"
                                        displayEmpty
                                        inputProps={{ 'aria-label': 'Select' }}
                                        value={template.style || ''}
                                        name="style"
                                        onChange={handleChangeDescTitle}>
                                        <MenuItem value="" disabled> {t("propertiesPage.select")} </MenuItem>
                                                               <MenuItem value={"Modern and Sleek"}>{t("descriptionDetails.modernAndSleek")}</MenuItem>
                                                               <MenuItem value={"Classic and Elegant"}>{t("descriptionDetails.classicAndElegant")}</MenuItem>
                                                               <MenuItem value={"Rustic and Charming"}>{t("descriptionDetails.rusticAndCharming")}</MenuItem>
                                                            </Select>
                                </FormControl>
                            </div>
                            <div className="col-md-6">
                                <label className="form-label-1 mb-2" htmlFor="selectTypeOpt"> {t("descriptionDetails.description")} </label>
                                <div className="d-flex">
                                    <div className="col-1 mb-3 marg-right-5">
                                        <label className="form-label-2 mb-2" htmlFor="selectTypeOpt">{t("descriptionDetails.minCharacters")}</label>
                                        <input type="number" min="0" className="form-input" placeholder="Min Characters" name="minCharactersDesc"
                                            onChange={handleChangeDescTitle} value={template.minCharactersDesc || ""} />
                                    </div>
                                    <div className="col-1 mb-3 marg-left-5">
                                        <label className="form-label-2 mb-2" htmlFor="selectTypeOpt">{t("descriptionDetails.maxCharacters")}  </label>
                                        <input type="number" min="0" className=" form-input" placeholder="Max Characters" name="maxCharactersDesc"
                                            onChange={handleChangeDescTitle} value={template.maxCharactersDesc || ""} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <label className="form-label-1 mb-2" htmlFor="selectTypeOpt">{t("descriptionDetails.title")}</label>
                                <div className="d-flex">
                                    <div className="col-1 mb-3 marg-right-5">
                                        <label className="form-label-2 mb-2" htmlFor="selectTypeOpt">{t("descriptionDetails.minCharacters")}</label>
                                        <input type="number" min="0" className="form-input" placeholder="Min characters" name="minCharactersTitle"
                                            onChange={handleChangeDescTitle} value={template.minCharactersTitle || ""} />
                                    </div>
                                    <div className="col-1 mb-3 marg-left-5">
                                        <label className="form-label-2 mb-2" htmlFor="selectTypeOpt"> {t("descriptionDetails.maxCharacters")}  </label>
                                        <input type="number" min="0" className=" form-input" placeholder="Max characters" name="maxCharactersTitle"
                                            onChange={handleChangeDescTitle} value={template.maxCharactersTitle || ""} />
                                    </div>
                                </div>
                            </div>
                            <div className="d-flex mt-1 align-items-center mb-4">
                                <div className="form-check col-12 col-md-auto mb-2 marg-right-16">
                                    <input className="form-check-input" type="checkbox" onChange={handleChangeCheck} name="agencyIntroduction" checked={template.agencyIntroduction ? template.agencyIntroduction : ""} />
                                    <label className="form-check-label" htmlFor="defaultCheck2" style={{ cursor: "pointer" }}>
                                        {t("generateDescTitle.addAgencyIntro")}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex justify-content-end">
                            <button className="button-dash back-EEF2FF color-4F52C1 border-4F52C1 border-6 padd-15-40 padd-10-15-mb width-auto bold-700 " onClick={UpdateTemplateHandler}>
                                 {t("propertiesPage.save")}
                            </button>
                        </div>
                    </div>

                </DialogContent>

            </Dialog>

        </>
    )
}
export default UpdateTemplate;